export default {
  loadingText: {
    id: 'bo-seller_default_loading-text',
    defaultMessage: 'Loading...',
  },
}
